import React, { Component } from 'react';
import _validator from 'modules/validator';
import _AdminService from 'modules/AdminService';
import _notification from 'modules/notification';
import { Card, Table, Modal, Icon } from 'antd';
import LoadingSpinner from 'components/enterprise/LoadingSpinner';
import PageHeader from 'components/enterprise/PageHeader';
import { routesAdmin } from 'routes/Routes';
import ConfirmPopup from '../popup/ConfirmPopup';
import MyInput from 'components/controls/MyInput';
import ButtonComponent from 'components/controls/Button';
import { GENERAL_ERROR_MESSAGE } from 'constants/constants';
import DropdownList from 'components/controls/DropdownList';

class QuestionAnswer_new extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pagination: { pageSize: 10, current: 1 },
            rowData: {
                Id: 0,
                Applied_PostId: 0,
                Center_Id: 0,
                ClassRoom_Id: 0,
                Description: "",
                FileName: "",
            },

            highlightedRowID: 0,

            classRoomList: [],
            filterClassRoomList: [],
            centerList: [],
            allStudentAnswerPaperList: [],

            loading: false,

            showModel: false,
            showMessageBox: false,

            fileNameError: "",
            centerError: "",
            classRoomError: "",

            Applied_PostId: 0,
        };
    }

    componentDidMount() {
        this.getAllClassRoom();
    }

    //API operations
    getAllClassRoom = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let classRoomList = await _AdminService.GetAllClassRoom();

                    this.getAllCenters();

                    this.setState({
                        ...this.state,
                        classRoomList: classRoomList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllCenters = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let centerList = await _AdminService.GetAllCenter();

                    centerList.data.map(item => {
                        item.Name = `${item.Name} (${item.PostName})`;
                    })

                    this.getAllStudentAnswerPaperList();

                    this.setState({
                        ...this.state,
                        centerList: centerList.data,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    getAllStudentAnswerPaperList = async () => {
        try {
            this.setState({ loading: true }, async () => {
                try {
                    let allStudentAnswerPaperList = await _AdminService.GetAllStudentAnswerPaperList();

                    let updatedAllStudentAnswerPaperList = [];

                    let allStudentAnswerPaperListData = allStudentAnswerPaperList.data

                    for(let i = 0;allStudentAnswerPaperListData.length > i; i++){
                        
                        let center = this.state.centerList.find(item => item.Id == allStudentAnswerPaperListData[i].Center_Id);
                        let classRoom = this.state.classRoomList.find(item => item.Id == allStudentAnswerPaperListData[i].ClassRoom_Id);

                        let obj = {
                            FileName: allStudentAnswerPaperListData[i].FileName.trim(),
                            Id: allStudentAnswerPaperListData[i].Id ? allStudentAnswerPaperListData[i].Id : 0,
                            Center_Id: allStudentAnswerPaperListData[i].Center_Id,
                            ClassRoom_Id: allStudentAnswerPaperListData[i].ClassRoom_Id,
                            Applied_PostId: allStudentAnswerPaperListData[i].Applied_PostId,
                            Description: "",
                            CenterName:center.Name,
                            ClassRoomName: classRoom.Name
                        }

                        updatedAllStudentAnswerPaperList.push(obj)
                    }

                    this.setState({
                        ...this.state,
                        allStudentAnswerPaperList: updatedAllStudentAnswerPaperList,
                        loading: false,
                    });

                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                }
            });
        } catch (e) { }
    }

    handleUpdate = async (input) => {
        if (this.validateFormData()) {
            return
        }

        const params = {
            FileName: this.state.rowData.FileName.trim(),
            Id: this.state.rowData.Id ? this.state.rowData.Id : 0,
            Center_Id: this.state.rowData.Center_Id,
            ClassRoom_Id: this.state.rowData.ClassRoom_Id,
            Applied_PostId: this.state.rowData.Applied_PostId,
            Description: ""
        }

        try {
            this.setState({ loading: true }, async () => {
                try {
                    const response = await _AdminService.AddOrUpdateStudentAnswerPaper(params);

                    if (response.status == 200) {

                        if (params.Id === 0) {
                            _notification.showMessage('success', "Saved successfully.");
                        }
                        else {
                            _notification.showMessage('success', "Updated successfully.");
                        }

                        this.setState({
                            centerError: "",
                            fileNameError: "",
                            showModel: false,
                            loading: false,
                            highlightedRowID: params.Id,
                            classRoomError: ""
                        });
                        this.getAllStudentAnswerPaperList();
                    }
                    else {
                        _notification.showMessage('error', response.data.message);
                    }
                } catch (e) {
                    // TODO
                    this.setState({ loading: false });
                    console.log('Error: ', e);
                    _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
                }
            });
        } catch (e) { }
    }

    deletePost = async (value) => {
        try {
            const response = await _AdminService.DeleteStudentAnswerPaper(this.state.rowData.Id);

            if (response.status == 200 && response.data.IsSuccess) {
                _notification.showMessage('success', "Deleted successfully.");
                this.setState({
                    centerError: "",
                    fileNameError: "",
                    showModel: false,
                    classRoomError: ""
                });
                this.getAllStudentAnswerPaperList();
            }
            else {
                _notification.showMessage('error', response.data.Message);
            }
        } catch (e) {
            _notification.showMessage('error', GENERAL_ERROR_MESSAGE);
        }
    }

    //Table action link clicks
    onEditClick = (value) => {

        let classRoom = this.state.classRoomList.filter(item => item.Center_Id == value.Center_Id)
        this.setState({
            rowData: {
                Id: value.Id,
                Applied_PostId: value.Applied_PostId,
                Center_Id: value.Center_Id,
                ClassRoom_Id: value.ClassRoom_Id,
                Description: value.Description,
                FileName: value.FileName,
            },
            filterClassRoomList: classRoom,
            showModel: true, highlightedRowID: 0, fileNameError: '', centerError: '', classRoomError: ''
        }, () => {
            window.scrollTo(0, 0);
        });
    };

    onDeleteClick = (value) => {
        this.setState({ rowData: value, showMessageBox: true, highlightedRowID: 0 });
    };

    onTableAction = (pagination, filters, sorter, extra) => {
        this.setState({ pagination: pagination, highlightedRowID: 0 });
    }

    //Message box confirm delete click
    onConfirmDelete = (value) => {
        this.setState({ showMessageBox: false });
        this.deletePost(value);
    }

    closeMessageBox(value = false) {
        this.setState({ showMessageBox: value });
    }

    // Add new record click
    onAddNewRecordClick(modelToggle) {
        this.setState({ showModel: modelToggle, rowData: {}, fileNameError: '', centerError: '', classRoomError: '' });
    }

    hideModelWindow() {
        this.setState({ showModel: false, rowData: {} });
    }

    onTextChange = ({ target: { name, value } }) => {
        this.setState({
            ...this.state,
            rowData: { Id: this.state.rowData.Id, ...this.state.rowData, [name]: value }
        });
    }

    onCenterChange = (event) => {

        let center = {}
        let classRoom = []
        console.log(this.state.classRoomList)
        if (event.target.value !== "") {
            center = this.state.centerList.find(item => item.Id == event.target.value);
            classRoom = this.state.classRoomList.filter(item => item.Center_Id == event.target.value)
        }


        this.setState({
            ...this.state,
            rowData: {
                ...this.state.rowData,
                Center_Id: event.target.value,
                Applied_PostId: center.AppliedPost_Id,
                ClassRoom_Id: ""
            },
            filterClassRoomList: classRoom
        });
    }

    onClassRoomChange = (event) => {
        this.setState({
            ...this.state,
            rowData: { ...this.state.rowData, ClassRoom_Id: event.target.value },
        });
    };

    validateFormData = () => {
        let body = this.state.rowData;

        this.setState({
            centerError: '',
            fileNameError: '',
            classRoomError: ''
        });

        let hasError = false;

        if (!body.FileName || !body.FileName.trim()) {
            this.setState({ fileNameError: 'Please enter valid File Name' });
            hasError = true
        }

        if (!body.Center_Id && body.Center_Id !== 0) {
            this.setState({ centerError: 'Please select valid Center.' });
            hasError = true
        }

        if (!body.ClassRoom_Id && body.ClassRoom_Id !== 0) {
            this.setState({ classRoomError: 'Please select valid Class Room.' });
            hasError = true
        }

        return hasError;
    }

    render() {
        const TableColumns = [
            {
                title: 'Center Name',
                dataIndex: 'CenterName',
                filterSearch: true,
                width: '20%',
                key: 'CenterName',
                sorter: (a, b) => a.CenterName > b.CenterName,
                filters: this.state.centerList ? this.state.centerList.map(item => ({ text: item.Name, value: item.Id })) : [],
                onFilter: (value, record) => record.Center_Id === value,
                // render: (value, record) => {
                //     let center = this.state.centerList.find(item => item.Id == record.Center_Id);
                //     return (!center ? "" : center.Name);
                // }
            },
            {
                title: 'Class Room',
                dataIndex: 'ClassRoomName',
                filterSearch: true,
                width: '20%',
                key: 'ClassRoomName',
                sorter: (a, b) => a.ClassRoomName > b.ClassRoomName,
                filters: this.state.centerList ? this.state.centerList.map(item => ({ text: item.Name, value: item.Id })) : [],
                onFilter: (value, record) => record.ClassRoom_Id === value,
                // render: (value, record) => {
                //     let classRoom = this.state.classRoomList.find(item => item.Id == record.ClassRoom_Id);
                //     return (!classRoom ? "" : classRoom.Name);
                // }
            },
            {
                title: 'File Name',
                dataIndex: 'FileName',
                filterSearch: true,
                width: '20%',
                key: 'FileName',
                sorter: (a, b) => a.FileName > b.FileName
            },
            {
                title: 'Action',
                dataIndex: '',
                key: 'Id',
                width: "20%",
                render: (value) => {
                    return (
                        <>
                            <ButtonComponent type="button" value="Edit" className="button-global button-border small autoHeight mr-2" onClick={(event) => this.onEditClick(value)} />
                            <ButtonComponent type="button" value="Delete" className="button-global button-danger small autoHeight" onClick={(event) => this.onDeleteClick(value)} />
                        </>
                    );
                }
            },
        ];

        if (this.state.loading)
            return <LoadingSpinner />

        return (
                <div className="container-fluid p-3">
                    <PageHeader
                        title="Question Answer"
                        breadcrumbItems={[{ label: 'Dashboard', path: routesAdmin.dashboard.path }, { label: 'Masters' }, { label: 'Question Answer' }]}
                    />
                    <div className="analysisWrap">
                            <div style={{ textAlign: 'right' }}>
                                {!this.state.showModel &&
                                    <div className="max1200 m-auto mb-2"> 
                                        <div className="d-flex align-items-center justify-content-end">
                                            <a className="button-global button-border addbutton autoWidth d-inline-block text-center autoHeight mb-3  d-flex align-items-center justify-content-center" 
                                            onClick={() => this.onAddNewRecordClick(true)}><Icon type="plus-circle" className="mr-2 font1rem" /> Add Question Answer PDF</a>
                                
                                        </div>
                                    </div>  
                                }
                            </div>

                           {/* Modal controls */}
                           {this.state.showModel &&         
                            <div className="max1200 m-auto">
                                <div className="ent-panel mb-4">
                                    <h4 className="heading4">{this.state.rowData ? this.state.rowData.Id > 0 ? "Update" : "Add" : "Add"} Question Answer PDF</h4>
                                    
                                    <div className="admin-inner-wrap p-3">
                                        
                                            <div className="row flex-sm-row ">
                                                <div className="col-sm-4">
                                                    <DropdownList
                                                        value={this.state.rowData.Center_Id}
                                                        name="Center_Id"
                                                        onChange={this.onCenterChange}
                                                        placeholder="Select Center"
                                                        heading={"Center"}
                                                        className="w-100"
                                                        wrapClass="wrap"
                                                        isRequired={true}
                                                        options={this.state.centerList}
                                                        errorState={this.state.centerError}
                                                        errorMessage={this.state.centerError}
                                                    />
                                                </div>
                                                {this.state.rowData.Center_Id && <div className="col-sm-4">
                                                    <DropdownList
                                                        value={this.state.rowData.ClassRoom_Id}
                                                        name="ClassRoom_Id"
                                                        onChange={this.onClassRoomChange}
                                                        placeholder="Select Class Room"
                                                        heading={"Class Room"}
                                                        className="w-100"
                                                        wrapClass="wrap"
                                                        isRequired={true}
                                                        options={this.state.filterClassRoomList}
                                                        errorState={this.state.classRoomError}
                                                        errorMessage={this.state.classRoomError}
                                                    />
                                                </div>}
                                                <div className="mb-2 col-sm-4">
                                                    <label htmlFor="category">File Name<span className="color-red">*</span></label>
                                                    <MyInput id="FileName"
                                                        type="text"
                                                        key="FileName"
                                                        name="FileName"
                                                        value={this.state.rowData.FileName ? this.state.rowData.FileName : ""}
                                                        onChange={this.onTextChange}
                                                        placeholder={"Enter File Name"}
                                                        isRequired={true}
                                                        errorState={this.state.fileNameError}
                                                        errorMessage={this.state.fileNameError} />
                                                </div>
                                            </div>
                                        
                                    </div>
                                    <div className="pt-4 buttonAlignCenter" >
                                        <button type="button" onClick={() => this.hideModelWindow()} className="button-global button-secondary mr-4 autoHeight small"><span>Cancel</span></button>
                                        <button type="button" onClick={this.handleUpdate} className="button-global button-primary autoHeight small"><span>Save</span></button>
                                    </div>
                                </div>
                            </div>
                            }
                            <div className="max1200 m-auto"> 
                                <Table size='small'
                                    bordered
                                    rowKey='Id'
                                    columns={TableColumns}
                                    dataSource={this.state.allStudentAnswerPaperList}
                                    pagination={this.state.pagination}
                                    footer={() => <label style={{ textAlign: 'right', marginRight: '20px' }}>Total Records: {this.state.allStudentAnswerPaperList.length}</label>}
                                    onChange={this.onTableAction}
                                    rowClassName={(record, index) => (index % 2 ? 'odd' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : '') :
                                        'even' + (record.Id === this.state.highlightedRowID ? 'scroll-row table-row-dark' : ''))}
                                    className="table-striped-rows admin-table"
                                />
                            </div>

                    </div>
                    <Modal
                    centered={true}
                    width={400}
                    className="modelPopAnt admin-home"
                    visible={this.state.showMessageBox}
                    onCancel={() => this.closeMessageBox(false)}
                    footer={false}
                >
                    <ConfirmPopup
                        onCancel={() => this.closeMessageBox(false)}
                        onOk={this.onConfirmDelete}
                        popupData={this.state.rowData}
                        message="Are you sure, you want to delete this Record?"
                    />
                </Modal>
                </div>
        )
    };
}

export default QuestionAnswer_new;